import { AvatarSize } from 'antd/lib/avatar/SizeContext';
import { FC } from 'react';
import styled from 'styled-components';
import Person16 from 'assets/svgs/placeholder-avatar/person/person-16.svg';
import Person24 from 'assets/svgs/placeholder-avatar/person/person-24.svg';
import Person40 from 'assets/svgs/placeholder-avatar/person/person-40.svg';
import { AvatarProps } from 'components/atoms/avatar/types';
import { AvatarWithFallback } from './avatar';

const getFallback = (size: AvatarSize | undefined) => {
  switch (size) {
    case 'large':
      return Person40;

    case 'small':
      return Person16;

    case 'default':
    default:
      return Person24;
  }
};

export const PersonAvatarWithFallback: FC<AvatarProps> = styled(
  AvatarWithFallback,
).attrs((props) => ({
  fallbackUrl: getFallback(props.size),
}))``;
